// extracted by mini-css-extract-plugin
export default {"seatingTable":"Overview_seatingTable__igSQ+","table":"Overview_table__89WIh","sticky":"Overview_sticky__esE3L","toolbar":"Overview_toolbar__lAis5"};